import Vue from 'vue'
import Router from 'vue-router'
import NotFound from '@/components/NotFound.vue'
// import Cookies from 'js-cookie'
import landing from '@/components/pages/landing.vue'
import company from '@/components/pages/company/company.vue'
import innovation from '@/components/pages/innovation/innovation.vue'
import productKDN1000 from '@/components/pages/product/product-0001.vue'
import productKDN13N from '@/components/pages/product/product-0002.vue'
import productKDNBR510 from '@/components/pages/product/product-0003.vue'
import recruit from '@/components/pages/recruit/recruit.vue'
import contactus from '@/components/pages/contactus/contactus.vue'
import policy from '@/components/pages/policy/policy.vue'
import privacy from '@/components/pages/policy/privacy.vue'

// vueにvue-routerを使用するように伝える
Vue.use(Router)

const routes = [
  {
    path: '*',
    name: 'NotFound',
    component: NotFound,
    meta: {
      title: 'NotFound'
    }
  },
  {
    name: 'landing',
    path: '/',
    component: landing,
    meta: {
      title: 'landing',
      requireLogin: false
    }
  },
  {
    name: 'company',
    path: '/company',
    component: company,
    meta: {
      title: 'company',
      requireLogin: false
    }
  },
  {
    name: 'innovation',
    path: '/innovation',
    component: innovation,
    meta: {
      title: 'innovation',
      requireLogin: false
    }
  },
  {
    name: 'productKDN1000',
    path: '/product/product-0001',
    component: productKDN1000,
    meta: {
      title: 'productKDN1000',
      requireLogin: false
    }
  },
  {
    name: 'productKDN13N',
    path: '/product/product-0002',
    component: productKDN13N,
    meta: {
      title: 'productKDN13N',
      requireLogin: false
    }
  },
  {
    name: 'productKDNBR510',
    path: '/product/product-0003',
    component: productKDNBR510,
    meta: {
      title: 'productKDNBR510',
      requireLogin: false
    }
  },
  {
    name: 'recruit',
    path: '/recruit',
    component: recruit,
    meta: {
      title: 'recruit',
      requireLogin: false
    }
  },
  {
    name: 'contactus',
    path: '/contactus',
    component: contactus,
    meta: {
      title: 'contactus',
      requireLogin: false
    }
  },
  {
    name: 'policy',
    path: '/policy',
    component: policy,
    meta: {
      title: 'policy',
      requireLogin: false
    }
  },
  {
    name: 'privacy',
    path: '/privacy',
    component: privacy,
    meta: {
      title: 'privacy',
      requireLogin: false
    }
  }
]

var router = new Router({
  mode: 'history',
  routes: routes
})

// let isOperator = path => {
//   if (path.search(/^\/operator\//) !== -1) return 'operatorlogin'
//   else return 'login'
// }
// トークンチェック
// router.beforeEach((to, from, next) => {
//   // const { meta } = to
//   // const { requireLogin } = meta
//   // let tokenId = Cookies.get('tokenId')
//   // const needLogin = requireLogin && (tokenId == null || tokenId === '')

//   // if (needLogin) {
//   //   return next({
//   //     name: isOperator(to.path),
//   //     params: {
//   //       nextUrl: to.fullPath
//   //     }
//   //   })
//   // }

//   // キャッシュしなし、リフレッシュする
//   to.meta.keepAlive = false
//   next()
// })

export default router



// WEBPACK FOOTER //
// ./src/router/index.js